import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

import {
  AgCellWrapperComponent,
  ICellWrapperParams,
} from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { DriverType } from '@shared/services/gql.service';

import { ForecastTableGridComponent } from '../../forecast-table-grid.component';
import {
  ForecastTableGridDataInterface,
  ForecastTableGridParentComponentContext,
} from '../../models/forecast-table-grid.model';

@Component({
  imports: [
    NgSelectComponent,
    FormsModule,
    TooltipDirective,
    NgClass,
    NgOptionTemplateDirective,
    AsyncPipe,
  ],
  selector: 'aux-forecast-table-grid-driver',
  styleUrls: ['./forecast-table-grid-driver.component.scss'],
  templateUrl: './forecast-table-grid-driver.component.html',
})
export class ForecastTableGridDriverComponent
  extends AgCellWrapperComponent
  implements ICellRenderer
{
  autoTestAttribute!: string;
  componentParent!: ForecastTableGridComponent;
  context!: ForecastTableGridParentComponentContext;
  data!: ForecastTableGridDataInterface;
  disableDriver = false;
  mapOptionAvailable = new Map<DriverType, Observable<boolean>>([]);
  params!: ICellRendererParams;
  value!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.context = this.params.context;
    this.componentParent = this.context.componentParent;

    this.mapOptionAvailable = new Map<DriverType, Observable<boolean>>([
      [DriverType.DRIVER_CUSTOM, this.context.forecastQuery.select('hasCustomCurves')],
      [DriverType.DRIVER_PATIENT, this.context.forecastQuery.select('hasPatientCurves')],
      [DriverType.DRIVER_SITE, this.context.forecastQuery.select('hasSiteCurves')],
      [DriverType.DRIVER_TIME, of(true)],
    ]);

    this.data = this.params.data;

    if (this.data) {
      this.data.driver = this.params.data.driver || undefined;
    }

    if (!this.componentParent.userHasModifyPermissions) {
      this.disableDriver = true;
    }

    this.value = this.params.value;
    this.autoTestAttribute = this.getAutoTestAttribute(params);
  }

  getAutoTestAttribute(params: ICellWrapperParams): string {
    const isTotalCell = params.node.rowPinned === 'bottom';

    const field = params.colDef?.field || '';
    const index = params.rowIndex;

    const fieldName = params.customLocator || field;

    return isTotalCell ? `${fieldName}_total` : `${fieldName}_${index}`;
  }

  getOptionAvailableTooltip(driverType: DriverType): string {
    const mapTooltipLabel = new Map<DriverType, string>([
      [DriverType.DRIVER_CUSTOM, 'Custom Curves'],
      [DriverType.DRIVER_PATIENT, 'Patient Curves'],
      [DriverType.DRIVER_SITE, 'Site Curves'],
    ]);

    const label = mapTooltipLabel.get(driverType);

    return label ? `No ${label} exist.` : '';
  }

  refresh(): boolean {
    return false;
  }
}
